const MUTATION_TYPES = {
  SET_CURRENT_USER: "SET_CURRENT_USER",
  SET_CHECKED_AUTH_STATE: 'SET_CHECKED_AUTH_STATE',
  SET_ACTIVE_COLOR: "SET_ACTIVE_COLOR",
  SET_MAPPING_TASK_AND_COLOR: "SET_MAPPING_TASK_AND_COLOR",
  //   TODO: 初回の主要データのfetch
  SET_SELECTING_TASKS: "SET_SELECTING_TASKS",
  SET_NOT_SELECTING_TASKS: "SET_NOT_SELECTING_TASKS",
  SET_CELL_LIST: "SET_CELL_LIST",
  // 色塗り画面で主に利用
  DELETE_CELL: "DELETE_CELL",
  ADD_CELL: "ADD_CELL",
  SUM_TASK_COUNT: "SUM_TASK_COUNT",
  RESET_CELL_LIST: "RESET_CELL_LIST",
  // タスク編集画面で主に利用
  SWAP_TASK: "SWAP_TASK",
  RENAME_TEXT: "RENAME_TEXT",
  DELETE_TASK: "DELETE_TASK",
};

export default MUTATION_TYPES;
